import { Injectable } from '@angular/core';
import { HttpService } from '../store/http/http.service';
import { RequestType } from '../store/http/http.service';
import { catchError, map } from 'rxjs/operators';
import { Organisation } from '../organisation/organisation.interface';
import { OrganisationService } from '../organisation/organisation.service';
import { ProjectService } from '../projects/project.service';
import { Observable, of } from 'rxjs';
import { ResourceData } from '../elements/resource/resource.types';
import { Project } from '../projects/project.interface';
import { User } from '../user/user.interface';
import { IRIToId } from '../util/iri';

export interface HomeResponse {
  organisations: ResourceData[];
  recentProjects: ResourceData[];
  project: ResourceData[];
}

@Injectable()
export class HomeService {
  getHome(): Observable<{
    user: User;
    organisations: Organisation[];
    recentProjects?: Project[];
    externalProjects?: Project[];
  }> {
    return this.http
      .requestCall({
        path: 'user/home-new',
        type: RequestType.GET,
      })
      .pipe(
        map(result => {
          // console.log('result', result);
          const { user, organisations, recentProjects, externalProjects } =
            result;
          console.log('recentProjects', recentProjects);
          return {
            user: {
              id: IRIToId(user.IRI),
              firstName: user.literals.firstName,
              lastName: user.literals.lastName,
              email: user.literals.email,
            },
            organisations: organisations.map(org =>
              this.organisationService.mapResourceToOrganisation(org),
            ),
            recentProjects: recentProjects.map(project =>
              this.projectService.mapResourceToProject(project),
            ),
            externalProjects: externalProjects?.map(project =>
              this.projectService.mapResourceToProject(project),
            ),
          };
        }),
        catchError(error => {
          console.error('error', error);
          return of({
            user: null,
            organisations: [],
            recentProjects: [],
            externalProjects: [],
          });
        }),
      );
  }

  // mapResourceToHome({ organisations, projects }): HomeData {
  //   return {
  //     organisations: organisations.map(organisation => t),
  //     projects: projects.map(project =>
  //       this.projectService.mapResourceToProject(project),
  //     ),
  //   };
  // }

  constructor(
    private readonly http: HttpService,
    private readonly organisationService: OrganisationService,
    private readonly projectService: ProjectService,
  ) {}
}
